export default {
    name: 'order',
    path: 'order',
    meta: {
        title: '订单管理'
    },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'order-version',
            path: 'version',
            meta: { title: '版本订单' },
            component: ()=>import('@/pages/order/version.vue')
        },
        {
            name: 'order-code',
            path: 'code',
            meta: { title: '溯源码订单' },
            component: ()=>import('@/pages/order/code.vue')
        },
        {
            name: 'order-plugin',
            path: 'plugin',
            meta: { title: '插件订单' },
            component: ()=>import('@/pages/order/plugin.vue')
        }
    ]
}